// /src/lib/auth.ts
'use client';

export function setToken(token: string) {
  document.cookie = `jwt=${token}; path=/; max-age=${60 * 60 * 24};`;
}

export function getToken(): string | null {
  const match = document.cookie.match(/(^| )jwt=([^;]+)/);
  return match ? match[2] : null;
}

export function clearToken() {
  document.cookie = 'jwt=; path=/; max-age=0';
}

export function isLoggedIn(): boolean {
  return !!getToken();
}
